import React from "react";
import batik from "../Accests/images/bathik/batik.jpg";
import silik from "../Accests/images/bathik/silik.jpg";
import coton from "../Accests/images/bathik/coton.jpg";

export const FabricStore = () => {
    const fabrics = [
        { src: batik, alt: "Batik Fabric", title: "Batik" },
        { src: silik, alt: "Silk Fabric", title: "Silk" },
        { src: coton, alt: "Cotton Fabric", title: "Cotton" },
    ];

    return (
        <section className="bg-yellow-50 py-12 px-6 text-center mt-10">
            <div className="max-w-5xl mx-auto">
                <h2 className="text-3xl font-bold text-yellow-800 mb-4">🧵 Welcome to Our Fabric Store</h2>

                <p className="bg-yellow-100 border-l-4 border-yellow-500 text-yellow-800 text-lg p-4 rounded-xl shadow-md mb-8">
                    <strong>Dear Sir/Madam</strong>, you can get the clothes you need — <span className="font-semibold">batik</span>, <span className="font-semibold">silk</span>, and <span className="font-semibold">cotton</span> — from our <span className="underline font-medium">fabric store</span>.
                </p>

                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                    {fabrics.map((fabric, index) => (
                        <div key={index} className="bg-white rounded-xl shadow-md p-4 hover:shadow-xl transition duration-300">
                            <img
                                src={fabric.src}
                                alt={fabric.alt}
                                className="rounded-lg object-cover h-60 w-full mb-3"
                            />
                            <h3 className="text-lg font-semibold text-yellow-800">{fabric.title}</h3>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};
